module.exports = __webpack_public_path__ + "img/calendar.4b731465.svg";